module.exports = __webpack_public_path__ + "img/course_001.15e6635.webp";